// Maps the raw 1..5 RQUCL score to user-facing strings per web-site-copy_v3.
// FR-007: never show the raw 1..5 scale to the user. The "strength %" pitch
// (1=20%, 5=100%) is the calibrated-advisor framing the CEO sells from.
//
// The qualitative labels (e.g. Rarity 4 = "Distinctive") come from Sonia's
// hifi mocks — each factor has its own label set keyed by score 1..5.

const QUALITATIVE_LABELS = {
  rarity: {
    1: 'Common',
    2: 'Available',
    3: 'Limited',
    4: 'Distinctive',
    5: 'Specialized',
  },
  quality: {
    1: 'Unverified',
    2: 'Inconsistent',
    3: 'Standardized',
    4: 'Validated',
    5: 'Clinical-grade',
  },
  usefulness: {
    1: 'Academic',
    2: 'Exploratory',
    3: 'Applied',
    4: 'Pipeline-ready',
    5: 'Actionable',
  },
  compliance: {
    1: 'Restricted',
    2: 'Partial',
    3: 'Compliant',
    4: 'Broad-consent',
    5: 'Commercial-ready',
  },
  linkageRichness: {
    1: 'Single-source',
    2: 'Basic',
    3: 'Connected',
    4: 'Multi-modal',
    5: 'Comprehensive',
  },
};

const FACTOR_TITLES = {
  rarity: 'Rarity',
  quality: 'Quality',
  usefulness: 'Usefulness',
  compliance: 'Compliance',
  linkageRichness: 'Linkage Richness',
};

// strengthPercent(3) => "60%" — never expose the underlying 1..5 to the UI.
export function strengthPercent(score) {
  const clamped = clampScore(score);
  return `${clamped * 20}%`;
}

// qualitativeLabel('rarity', 4) => "Distinctive". Returns empty string for
// unknown factors so callers can safely template against it.
export function qualitativeLabel(factor, score) {
  const map = QUALITATIVE_LABELS[factor];
  if (!map) return '';
  const clamped = clampScore(score);
  return map[clamped] ?? '';
}

// factorTitle('linkageRichness') => "Linkage Richness". Same fallback rule.
export function factorTitle(factor) {
  return FACTOR_TITLES[factor] ?? factor;
}

function clampScore(score) {
  const n = Number(score);
  if (!Number.isFinite(n)) return 3;
  if (n < 1) return 1;
  if (n > 5) return 5;
  return Math.round(n);
}
